import { ValueObject } from '@nx-smartmonkey/shared/domain';

interface ProjectViewClientProps {
  external_id: boolean;
  location_details: boolean;
  comments: boolean;
  reference_person: boolean;
  phone: boolean;
  email: boolean;
  url: boolean;
  optional: boolean;
}

export class ProjectViewClient extends ValueObject<ProjectViewClientProps> {
  get external_id(): boolean {
    return this.props.external_id;
  }
  set external_id(externalId: boolean) {
    this.props.external_id = externalId;
  }
  get location_details(): boolean {
    return this.props.location_details;
  }
  set location_details(locationDetails: boolean) {
    this.props.location_details = locationDetails;
  }
  get comments(): boolean {
    return this.props.comments;
  }
  set comments(comments: boolean) {
    this.props.comments = comments;
  }
  get reference_person(): boolean {
    return this.props.reference_person;
  }
  set reference_person(referencePerson: boolean) {
    this.props.reference_person = referencePerson;
  }
  get phone(): boolean {
    return this.props.phone;
  }
  set phone(phone: boolean) {
    this.props.phone = phone;
  }
  get email(): boolean {
    return this.props.email;
  }
  set email(email: boolean) {
    this.props.email = email;
  }
  get url(): boolean {
    return this.props.url;
  }
  set url(url: boolean) {
    this.props.url = url;
  }
  get optional(): boolean {
    return this.props.optional;
  }
  set optional(optional: boolean) {
    this.props.optional = optional;
  }
  private constructor(props: ProjectViewClientProps) {
    super(props);
  }

  static create(props: ProjectViewClientProps): ProjectViewClient {
    return new ProjectViewClient(props);
  }
}
